import { useContext } from "react";

import { ThemeContext } from "@/shared/theme/ThemeProvider";

/** The theme preference, the theme on screen, and a way to change the preference. */
export function useTheme() {
  const context = useContext(ThemeContext);
  if (context === null) {
    throw new Error("useTheme must be used inside ThemeProvider");
  }
  return context;
}
